import api from '../api'

const initialState = { 
    mute: (localStorage.getItem('sound') == 'false'),
    currentBgMusic: null,
    audioClips: {
        "Button" : { file: "sfx-button.wav", audio: null },
        "Button_OnOff" : { file: "sfx-btn-on-off.wav", audio: null },
        "Error" : { file: "sfx-error.wav", audio: null },
        "Message" : { file: "sfx-message.wav", audio: null },
        "Settings_Click" : { file: "sfx-settings-click.wav", audio: null },
        "Collect_Diamonds" : { file: "sfx-collect-diamonds.wav", audio: null },
        "Collect_Gold" : { file: "sfx-collect-gold.wav", audio: null },
        "Collect_Resources" : { file: "sfx-collect-resources.wav", audio: null },
        "Collect_Item" : { file: "sfx-collect-item.wav", audio: null },
        "Resources_Click" : { file: "sfx-resources-click.wav", audio: null },
        "Tab_Click" : { file: "sfx-tab-click.wav", audio: null },
        "Achievements" : { file: "sfx-achievements.mp3", audio: null },
        "Fail" : { file: "sfx-fail.wav", audio: null },
        "Drop" : { file: "sfx-drop.wav", audio: null },
        "Timer" : { file: "sfx-timer.wav", audio: null },
        "SpinDone" : { file: "sfx-spin-done.mp3", audio: null },
        "BG_Home" : { file: "bgmusic-home.mp3", audio: null },
        "BG_TriviaQuiz" : { file: "bgmusic-triviaquiz.mp3", audio: null },
        "BG_Shop" : { file: "bgmusic-shop.mp3", audio: null },
        "BG_Questions" : { file: "bgmusic-questions.mp3", audio: null },
        "BG_QuizActive" : { file: "bgmusic-quiz-active.mp3", audio: null },
        "BG_QuizWait" : { file: "bgmusic-quiz-wait.mp3", audio: null },
    }
};

export const sound = {
    namespaced: true,
    state: initialState,
    fadeOutAudio: null,
    old: null,
    currentBgKey: null,
    actions: {
        sfx({ commit }, key){
            commit('playSfx', key);
            return Promise.resolve(key);
        },
        bg({ commit }, key){
            commit('playBg', key);
            return Promise.resolve(key);
        },
        mute({ commit }, status){
            commit('mute', status);
            return Promise.resolve(status);
        },
        pauseBg({ commit }, status){
            commit('pauseBg', status);
            return Promise.resolve(status);
        },
    },
    mutations: {
        
        mute(state, mute) {
            state.mute = mute;
            localStorage.setItem('sound', !mute);
            for(let c in state.audioClips){
                if(state.audioClips[c].audio != null) state.audioClips[c].audio.muted = mute;
            }
        },

        playSfx(state, key) {
            if(state.audioClips[key].audio == null)
                state.audioClips[key].audio = new Audio("/audio/"+state.audioClips[key].file);
            
            state.audioClips[key].audio.muted = state.mute;
            state.audioClips[key].audio.volume = 1;
            state.audioClips[key].audio.currentTime = 0;
            state.audioClips[key].audio.play();
        },

        playBg(state, key) {
            if (this.currentBgKey == key) return; // same

            if (this.fadeOutAudio != null) {
                clearInterval(this.fadeOutAudio);
                this.fadeOutAudio = null;
                this.old.volume = 0;
            }

            if(state.currentBgMusic != null) {
                this.old = state.currentBgMusic;
                const $this = this;
                this.fadeOutAudio = setInterval(function () {
                    // Only fade if past the fade out point or not at zero already
                    $this.old.volume = $this.old.volume - 0.1 < 0 ? 0 : $this.old.volume - 0.1;
                    if ($this.old.volume <= 0) {
                        clearInterval($this.fadeOutAudio);
                        $this.fadeOutAudio = null;
                    }
                }, 200);
            }
            
            this.currentBgKey = key;
            if(state.audioClips[key].audio == null)
                state.audioClips[key].audio = new Audio("/audio/"+state.audioClips[key].file);

            state.currentBgMusic = state.audioClips[key].audio;
            state.currentBgMusic.volume = 0.4;
            state.currentBgMusic.loop = 1;
            state.currentBgMusic.muted = state.mute;
            state.currentBgMusic.currentTime = 0;
            state.currentBgMusic.play();
        },

        pauseBg(state, status){
            if(state.currentBgMusic != null) {
                if(status) state.currentBgMusic.pause();
                else state.currentBgMusic.play();
            }
        }
    }
};